import EventService from "@viz-ui/services/eventService/eventService";
import i18n from "@viz-ui/i18n/i18n";

const EXPORT_XLS_CELL_LIMIT_EXCEEDED_EVENT = "exportXls.cellLimitExceeded";
const XLS_CELL_LIMIT_EXCEEDED_ERROR_KEY = "_Export.Xls.error.cell_limit_exceeded_";

angular.module("highbond.visualizer.downloadXlsModal").run(["$rootScope", "Localize", downloadXlsExportCellLimitRun]);

function getLocalizedErrorMessage(Localize, key) {
  const fromI18n = i18n.t(key);
  if (fromI18n !== key) {
    return fromI18n;
  }
  return Localize.getLocalizedString(key);
}

function downloadXlsExportCellLimitRun($rootScope, Localize) {
  $rootScope.xlsExportCellLimitBlocked = false;

  const eventService = EventService.register("downloadXlsModal");
  eventService.subscribe(EXPORT_XLS_CELL_LIMIT_EXCEEDED_EVENT, () => {
    $rootScope.$applyAsync(() => {
      $rootScope.xlsExportCellLimitBlocked = true;
      $rootScope.xlsExportCellLimitTooltip = getLocalizedErrorMessage(Localize, XLS_CELL_LIMIT_EXCEEDED_ERROR_KEY);
    });
  });
}
